// @ts-nocheck
import { useState, useEffect } from 'react';
import { PurpleSelectTrigger } from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/PurpleSelectTrigger';
import { PurpleSuffixInput } from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/PurpleSuffixInput';
import { StyledPurpleSelectWrapper } from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/styles';
import { EventConditionInputContainer, StyledBasicSelect, StyledPrefix } from '../Styled';
import {
  comparatorOptions,
  ComparatorOptionsWithNoValueRequirement,
  ComparatorOptionsWithNoSymbols,
} from '../constants';

export const PurchaseCondition = ({ id, onUpdate, query = {} }) => {
  const { value, comparator } = query;
  const [isNoSymbol, setIsNoSymbol] = useState(ComparatorOptionsWithNoSymbols.includes(comparator));

  useEffect(() => {
    setIsNoSymbol(ComparatorOptionsWithNoSymbols.includes(comparator));
  }, [comparator]);

  const updateComparator = (newComparator) => {
    // create the query and send back to parent
    if (ComparatorOptionsWithNoValueRequirement.includes(newComparator)) {
      onUpdate({ value: undefined, comparator: newComparator });
    } else {
      onUpdate({
        ...query,
        comparator: newComparator,
      });
    }
  };

  const updatePurchaseValue = (purchaseValue) => {
    // create the query and send back to parent
    onUpdate({
      ...query,
      value: purchaseValue,
    });
  };
  return (
    <EventConditionInputContainer data-test={`${id}_PurchaseCondition`}>
      {
        <>
          <StyledBasicSelect
            id={`${id}_PurchaseConditionComparator`}
            defaultValues={[comparator]}
            options={comparatorOptions.long}
            onSelect={([newComparator]) => updateComparator(newComparator)}
            suffixUsed={!isNoSymbol}
            SelectWrapper={StyledPurpleSelectWrapper}
            Trigger={PurpleSelectTrigger}
          />
          {!ComparatorOptionsWithNoValueRequirement.includes(comparator) && (
            <PurpleSuffixInput
              id={`${id}_PurchaseConditionValue`}
              Prefix={<StyledPrefix>{`$`}</StyledPrefix>}
              value={value}
              onChange={updatePurchaseValue}
            />
          )}
        </>
      }
    </EventConditionInputContainer>
  );
};
